module.exports = __webpack_public_path__ + "static/media/icon-sandbox.c669473d.svg";